// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booking-calendar-multi-page .nav-tabs{flex-wrap:nowrap !important}.booking-calendar-multi-page .lx-page-container{overflow-y:hidden}.booking-calendar-multi-page .lx-page-container .color-select-menu{width:100% !important;max-height:200px !important;overflow-y:auto !important}", ""]);
// Exports
module.exports = exports;
